<ui-ecommerce-product-wizard-actions-panel-product-selection
  *ngIf="showECommerceProductWizardActionsPanel"
  [storeProductMode]="storeProductMode"
  [storeType]="storeType$ | async"
  (returnToStoreButtonClick)="close()"
>
</ui-ecommerce-product-wizard-actions-panel-product-selection>

<gd-fixed-width-container [width]="1000">
  <ui-page-header [text]="'txt_choose_product_page_title' | translate">
    <gd-product-template-name-search-field
      [templateName]="templateName$ | async"
      (templateNameChange)="onTemplateNameChange($event)"
    >
    </gd-product-template-name-search-field>
  </ui-page-header>

  <gd-product-catalogue-templates-list-page-tab-links
    *ngIf="showTemplatesTab$ | async"
    [rootPath]="rootPath"
    [isTemplatesTabActive]="true"
  ></gd-product-catalogue-templates-list-page-tab-links>

  <ng-container [ngSwitch]="(itemsCount$ | async) > 0">
    <ng-container *ngSwitchCase="true">
      <div class="top-controls">
        <div class="ui form sorting-params">
          <div class="field">
            <label data-lokalise data-key="txt_sort_by_field_label"></label>
            <gd-product-templates-list-sorting-order-selector
              [sortingParams]="sortingParams$ | async"
              (sortingParamsChange)="onSortingParamsChange($event)"
            >
            </gd-product-templates-list-sorting-order-selector>
          </div>
        </div>
        <button
          class="ui primary button"
          (click)="onCreateTemplateButtonClick()"
          data-lokalise
          data-key="txt_create_template"
        ></button>
      </div>
      <gd-product-templates-list
        [items]="items$ | async"
        [showPlaceOrderButton]="showPlaceOrderButton"
        infiniteScrollContainer=".layout-content-product-catalogue"
        (placeOrderButtonClick)="onPlaceOrderButtonClick($event)"
        (addToStoreButtonClick)="onAddToStoreButtonClick($event)"
        (editButtonClick)="onEditButtonClick($event)"
        (renameButtonClick)="onRenameButtonClick($event)"
        (duplicateButtonClick)="onDuplicateButtonClick($event)"
        (deleteButtonClick)="onDeleteButtonClick($event)"
        (scrollDown)="onScrollDown()"
      ></gd-product-templates-list>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <gd-product-templates-list-empty-state
        (createTemplateButtonClick)="onCreateTemplateButtonClick()"
      ></gd-product-templates-list-empty-state>
    </ng-container>
  </ng-container>
</gd-fixed-width-container>

<ui-full-screen-spinner *ngIf="(isLoading$ | async) || (isProcessing$ | async)"></ui-full-screen-spinner>
